export default __webpack_public_path__ + "static/122-min-min-926a240ad6d5d1a824822373219093b0.jpg";